import { createMiddleware } from "@tanstack/react-start";
import { getAuthSession } from "#/modules/util.auth/session.auth.server";
import { resolveClientIp } from "#/modules/util.instrumentation/client-ip.server";
import { setSentryUser } from "#/modules/util.instrumentation/sentry";

/**
 * Puts the signed-in user on the server Sentry scope for every request (SSR loaders, server
 * routes, server functions), so the log lines and events written during that request carry
 * `user.email` and a support question ("this docent sees an error") can be answered by searching
 * for the email. The client IP goes along, so the anonymous requests of a device on the same
 * school network (a tablet that never gets past login) can be found next to the user's own.
 * The browser scope is synced separately in `syncSentryScope`.
 */
export const sentryUserMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    const session = await getAuthSession();
    setSentryUser(session.data.user?.email, resolveClientIp());
  } catch {
    // Instrumentation only: an unreadable session cookie must not fail the request.
  }
  return next();
});
